// Loader.tsx
import React from 'react'

interface LoaderProps {
  loading: boolean
}

const Loader: React.FC<LoaderProps> = ({ loading }) => {
  if (!loading) return null

  return (
    <div className="spinner-load">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  )
}

export default Loader
